/* eslint-disable */
import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, Download, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { adminApi } from "@/lib/adminApi";

export default function AdminDocumentLibraryTab() {
  const [documents, setDocuments] = useState([]);
  const [newDoc, setNewDoc] = useState({ title: "", file_url: "", visibility: "admin_only" });

  const load = async () => {
    const { data } = await adminApi.get("/admin/documents");
    setDocuments(data.documents || []);
  };
  useEffect(() => { load().catch(() => {}); }, []);

  const create = async () => {
    if (!newDoc.title || !newDoc.file_url) return toast.error("Title and URL required");
    await adminApi.post("/admin/documents", newDoc);
    toast.success("Document added");
    setNewDoc({ title: "", file_url: "", visibility: "admin_only" });
    await load();
  };

  return (
    <div className="space-y-4" data-testid="admin-docs-tab">
      <div className="rounded-md border border-[var(--rg-amber)] bg-[var(--rg-amber-soft)] p-3 text-xs text-[var(--rg-amber)]">
        <AlertTriangle className="w-4 h-4 inline mr-2" />
        SCAFFOLD — file-upload storage (S3 / local disk) is not yet wired. For now, paste a hosted file URL. Send-to-users (Resend) is also pending.
      </div>
      <div className="rounded-lg border border-[var(--rg-border)] bg-[var(--rg-surface)] p-4 grid sm:grid-cols-3 gap-3 items-end">
        <div>
          <Label className="text-[var(--rg-text)] text-xs uppercase">Title</Label>
          <Input value={newDoc.title} onChange={(e) => setNewDoc({ ...newDoc, title: e.target.value })} className="bg-[var(--rg-surface)] border-[var(--rg-border)] text-[var(--rg-text-strong)]" data-testid="doc-title" />
        </div>
        <div>
          <Label className="text-[var(--rg-text)] text-xs uppercase">File URL</Label>
          <Input value={newDoc.file_url} onChange={(e) => setNewDoc({ ...newDoc, file_url: e.target.value })} placeholder="https://…/file.pdf" className="bg-[var(--rg-surface)] border-[var(--rg-border)] text-[var(--rg-text-strong)]" data-testid="doc-url" />
        </div>
        <div>
          <Label className="text-[var(--rg-text)] text-xs uppercase">Visibility</Label>
          <select value={newDoc.visibility} onChange={(e) => setNewDoc({ ...newDoc, visibility: e.target.value })} className="bg-[var(--rg-surface)] border border-[var(--rg-border)] text-[var(--rg-text-strong)] text-sm rounded px-2 py-1.5 w-full" data-testid="doc-visibility">
            <option value="public">Public</option>
            <option value="users_only">Users Only</option>
            <option value="admin_only">Admin Only</option>
          </select>
        </div>
        <div className="sm:col-span-3">
          <Button size="sm" onClick={create} className="bg-[var(--rg-sage)] text-[var(--rg-on-sage)] hover:bg-[var(--rg-sage-hover)] font-semibold" data-testid="doc-create">
            <Plus className="w-4 h-4 mr-1.5" /> Add Document
          </Button>
        </div>
      </div>
      <div className="rounded-lg border border-[var(--rg-border)] bg-[var(--rg-surface)]">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[10px] uppercase tracking-[0.18em] text-[var(--rg-muted)] border-b border-[var(--rg-border)]">
              <th className="py-2 px-3">Title</th>
              <th className="py-2 px-3">Visibility</th>
              <th className="py-2 px-3">URL</th>
            </tr>
          </thead>
          <tbody>
            {documents.map((d) => (
              <tr key={d.id} className="border-b border-[var(--rg-border)]/60">
                <td className="py-2 px-3 text-[var(--rg-text-strong)]">{d.title}</td>
                <td className="py-2 px-3 text-[var(--rg-text)]">{d.visibility}</td>
                <td className="py-2 px-3"><a href={d.file_url} target="_blank" rel="noopener noreferrer" className="text-[var(--rg-sage)] hover:underline text-xs font-mono">{d.file_url}</a></td>
              </tr>
            ))}
            {documents.length === 0 && (<tr><td colSpan={3} className="py-6 text-center text-[var(--rg-muted)]">No documents yet.</td></tr>)}
          </tbody>
        </table>
      </div>
    </div>
  );
}

